import React from 'react'
import { cn } from '../../lib/utils'
import pharma4linkLogo from '../../assets/logos/pharma4link.svg'
import broxelEqsLogo from '../../assets/logos/broxel-eqs.svg'

/**
 * Broxel EQS renders at this fraction of the Pharma4Link width. Fixed here rather
 * than passed in, so the endorsement hierarchy cannot drift as pages choose sizes.
 */
const ENDORSER_SCALE = 0.95

interface BrandLockupProps {
  /** Pharma4Link logo width in px. Broxel EQS is sized from it. */
  width?: number
  /** Outer layout only — margins, alignment. Not size. */
  className?: string
}

/**
 * "Pharma4Link — empowered by Broxel EQS", side by side.
 *
 * Two things here are deliberate and should not be "tidied up":
 *
 * 1. dir="ltr" — the lockup must never mirror in Arabic. Same rule as the Broxel B
 *    staying to the left of its word in RTL.
 * 2. "empowered by" is a hardcoded English string, NOT an i18n key. It stays English
 *    in both languages by explicit decision. Moving it into en/ar JSON would invite a
 *    well-meaning translation later.
 */
const BrandLockup: React.FC<BrandLockupProps> = ({ width = 132, className }) => (
  <div
    dir="ltr"
    role="img"
    aria-label="Pharma4Link — empowered by Broxel EQS"
    className={cn('flex items-center justify-center gap-3.5', className)}
  >
    <img src={pharma4linkLogo} alt="" aria-hidden style={{ width }} />

    <span aria-hidden className="w-px shrink-0 self-stretch bg-gray-200" />

    <div className="text-center">
      <span
        aria-hidden
        className="block whitespace-nowrap text-[9px] font-semibold uppercase tracking-[0.13em] text-gray-400"
      >
        empowered by
      </span>
      <img
        src={broxelEqsLogo}
        alt=""
        aria-hidden
        className="mt-1"
        style={{ width: Math.round(width * ENDORSER_SCALE) }}
      />
    </div>
  </div>
)

export default BrandLockup
